import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function CentralizeEmails() {
    return (
        <OnboardingBody
            statusText='New: Shared email inbox'
            title='Centralize customer emails and respond to them as a team'
        >
            <p>
                Use a shared email address to forward all messages, reply from that same address,
                and create rules for generating leads and assigning threads to the team.
            </p>
        </OnboardingBody>
    );
}
